import { BreathingExercisesCard } from "./components/BreathingExercisesCard/BreathingExercisesCard";
import { GeneralActivityTrackerProgressTile } from "./components/GeneralActivityTrackerProgressTile/GeneralActivityTrackerProgressTile";
import { LeaderboardsSingleCard } from "./components/LeaderboardsSingleCard/LeaderboardsSingleCard";
import { SupportMomentsCard } from "./components/SupportMomentsCard/SupportMomentsCard";
import { SleepTrackerProgressTile } from "./components/SleepTrackerProgressTile/SleepTrackerProgressTile";
import { StepsTrackerProgressTile } from "./components/StepsTrackerProgressTile/StepsTrackerProgressTile";
import { WaterTrackerProgressTile } from "./components/WaterTrackerProgressTile/WaterTrackerProgressTile";
import { WisdomModules } from "shared/constants/Modules";
import { t } from "i18next";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { useUserContext } from "core/state/UserContext/UserContext";
import { useTwoColumnLayout } from "shared/core/hooks/useTwoColumnLayout";
import { MoodTrackerModule } from "../Home/components/MoodTrackerModule/MoodTrackerModule";
import { PositiveYouCard } from "../Home/components/PositiveYouCard/PositiveYouCard";
import { HealthSyncInfo } from "./components/HealthSyncInfo/HealthSyncInfo";

function TrackerComponents() {
  return (
    <div>
      <p className="mb-5 col-start-1">
        {t("wellbeing.headingParagraph")}
        <HealthSyncInfo modalId="wellbeing-info" className="align-middle ml-2" />
      </p>
      <div className="grid grid-cols-2 gap-x-11 gap-y-2">
        <WaterTrackerProgressTile />
        <StepsTrackerProgressTile />
        <SleepTrackerProgressTile />
        <GeneralActivityTrackerProgressTile />
      </div>
    </div>
  );
}

export const Wellbeing = () => {
  const { isPermitted } = useUserContext();

  let componentList = [
    { condition: isPermitted(WisdomModules.trackers), content: <TrackerComponents /> },
    { condition: isPermitted(WisdomModules.moodTracker), content: <MoodTrackerModule /> },
    { content: <PositiveYouCard /> },
    { content: <SupportMomentsCard /> },
    { condition: isPermitted(WisdomModules.leaderBoards), content: <LeaderboardsSingleCard /> },
    { content: <BreathingExercisesCard /> },
  ];
  const layout = useTwoColumnLayout(componentList);

  return (
    <>
      <PageTitle title={t("pageTitle.wellbeing.home")} />
      {layout}
    </>
  );
};